import React from "react";

import { NotFound } from "../views/notFound";
import PrivateRoute from "./PrivateRoute";

export const NotFoundRoute = (): React.ReactElement => {
    return <PrivateRoute path="*" exact={true} component={NotFound}/>;
};